import { AUTHZ_FEATURES, AUTHZ_OBJECTS, AUTHZ_ACTIONS } from './features.constants';

export const ACCESS = Object.freeze({
  PUBLIC_AUTHENTICATED: null,
  SUPER_ADMIN_ONLY: Object.freeze({ policy: 'super_admin_only' }),

  INTERVENE_VIEW: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.INTERVENE.DASHBOARD },
      { feature: AUTHZ_FEATURES.INTERVENE.CALLING },
      { feature: AUTHZ_FEATURES.INTERVENE.CHAT },
    ],
  }),
  EDTECH_CONCEPT_BUILDER: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.CONCEPT_BUILDER }],
  }),
  EDTECH_PRACTICE_TEST: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.PRACTICE_TEST }],
  }),
  EDTECH_KNOWLEDGE_MAP: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.KNOWLEDGE_MAP }],
  }),
  EDTECH_PERFORMANCE_MAP: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.PERFORMANCE_MAP }],
  }),
  EDTECH_PARENT_DASHBOARD: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.PARENT_DASHBOARD }],
  }),
  EDTECH_TEACHER_DASHBOARD: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.TEACHER_DASHBOARD }],
  }),
  EDTECH_ACADEMIC_INFO: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.ACADEMIC_INFO }],
  }),
  EDTECH_QUESTION_BANK: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.QUESTION_BANK }],
  }),
  EDTECH_SYLLABUS_BUILDER: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.SYLLABUS_BUILDER }],
  }),
  AI_DASHBOARD_VIEW: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.AI }],
  }),
  VECTOR_DATABASE_VIEW: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.VECTOR_DATABASE }],
  }),
  TOOLS_VIEW: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.EDTECH.TOOLS }],
  }),
  INTERVENE_CALLING: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.INTERVENE.CALLING }],
  }),
  INTERVENE_CHAT: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.INTERVENE.CHAT }],
  }),

  WHATSAPP_TEMPLATES_VIEW: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_CREATE },
      { object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_UPDATE },
      { object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_DELETE },
      { feature: AUTHZ_FEATURES.WHATSAPP.SEND_TEMPLATE },
      { feature: AUTHZ_FEATURES.WHATSAPP.TEMPLATE_PERFORMANCE },
    ],
  }),
  WHATSAPP_OPTIN: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.WHATSAPP.OPTIN_USERS }],
  }),
  WHATSAPP_WABA: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.WHATSAPP.WABA_APP_LIST }],
  }),
  WHATSAPP_TEMPLATE_PERFORMANCE: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.WHATSAPP.TEMPLATE_PERFORMANCE }],
  }),
  WHATSAPP_TEMPLATE_SEND: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.WHATSAPP.SEND_TEMPLATE }],
  }),

  SMS_TEMPLATES_VIEW: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.SMS_TEMPLATE, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.SMS_TEMPLATE, action: AUTHZ_ACTIONS.CAN_CREATE },
      { object: AUTHZ_OBJECTS.SMS_TEMPLATE, action: AUTHZ_ACTIONS.CAN_UPDATE },
      { object: AUTHZ_OBJECTS.SMS_TEMPLATE, action: AUTHZ_ACTIONS.CAN_DELETE },
      { feature: AUTHZ_FEATURES.SMS.SEND_TEMPLATE },
    ],
  }),
  SMS_TEMPLATE_SEND: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.SMS.SEND_TEMPLATE }],
  }),
  SMS_TEMPLATE_CREATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.SMS_TEMPLATE, action: AUTHZ_ACTIONS.CAN_CREATE }],
  }),
  SMS_TEMPLATE_UPDATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.SMS_TEMPLATE, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  SMS_LOGS_VIEW: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.SMS.VIEW_LOGS },
      { feature: AUTHZ_FEATURES.SMS.DOWNLOAD_LOGS },
    ],
  }),

  FLOW_VIEW: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_CREATE },
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_UPDATE },
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_DELETE },
      { feature: AUTHZ_FEATURES.FLOW.PUBLISH },
    ],
  }),
  FLOW_BUILDER: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_CREATE },
      { object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_UPDATE },
    ],
  }),
  FLOW_CREATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_CREATE }],
  }),
  FLOW_UPDATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  FLOW_DELETE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.FLOW, action: AUTHZ_ACTIONS.CAN_DELETE }],
  }),
  FLOW_PUBLISH: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.FLOW.PUBLISH }],
  }),

  DATASETS_VIEW: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.DATASET, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.DATASET_RECORD, action: AUTHZ_ACTIONS.CAN_VIEW },
    ],
  }),

  REPORTING_VIEW: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.REPORTING.VIEW },
      { feature: 'can_view_report_sidebar' },
      { feature: 'can_view_report' },
      { feature: 'can_view_analytics' },
      { feature: 'can_view_analsytics' },
      { feature: 'can_create_report' },
      { feature: 'can_create_custom_reports' },
      { feature: 'can_view_entity_report' },
      { feature: 'can_view_campaign_report' },
      { feature: 'can_view_benchmarking_report' },
      { feature: 'reporting' },
      { feature: 'analytics' },
    ],
  }),

  ANALYTICS_VIEW: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.ANALYTICS.VIEW },
      { feature: AUTHZ_FEATURES.REPORTING.VIEW },
      { feature: 'can_view_report_sidebar' },
      { feature: 'can_view_report' },
      { feature: 'can_view_analytics' },
      { feature: 'can_view_analsytics' },
      { feature: 'can_create_report' },
      { feature: 'can_create_custom_reports' },
      { feature: 'can_view_entity_report' },
      { feature: 'can_view_campaign_report' },
      { feature: 'can_view_benchmarking_report' },
      { feature: 'reporting' },
      { feature: 'analytics' },
    ],
  }),
  ANALYTICS_CREATE: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.ANALYTICS.CREATE }],
  }),
  ANALYTICS_DELETE: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.ANALYTICS.DELETE }],
  }),
  ANALYTICS_EXPORT: Object.freeze({
    anyOf: [{ feature: AUTHZ_FEATURES.ANALYTICS.EXPORT }],
  }),
  ANALYTICS_RECORDS: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.ANALYTICS.RECORDS },
      { feature: AUTHZ_FEATURES.RECORDS.VIEW },
    ],
  }),
  ANALYTICS_WHATSAPP: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.ANALYTICS.WHATSAPP },
      { feature: AUTHZ_FEATURES.WHATSAPP.TEMPLATE_PERFORMANCE },
    ],
  }),
  ANALYTICS_INTERVENE: Object.freeze({
    anyOf: [
      { feature: AUTHZ_FEATURES.ANALYTICS.INTERVENE },
      { feature: AUTHZ_FEATURES.INTERVENE.DASHBOARD },
      { feature: AUTHZ_FEATURES.INTERVENE.CHAT },
    ],
  }),

  PROFILE_MANAGEMENT_VIEW: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_CREATE },
      { object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_UPDATE },
      { object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_DELETE },
    ],
  }),
  /** @deprecated Use PROFILE_UPDATE — kept for existing imports */
  PROFILE_MANAGE: Object.freeze({
    anyOf: [{ object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  PROFILE_CREATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_CREATE }],
  }),
  PROFILE_UPDATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  PROFILE_DELETE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.PROFILE, action: AUTHZ_ACTIONS.CAN_DELETE }],
  }),
  USER_MANAGEMENT_VIEW: Object.freeze({
    anyOf: [
      { object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_VIEW },
      { object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_CREATE },
      { object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_UPDATE },
      { object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_DELETE },
    ],
  }),
  USER_CREATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_CREATE }],
  }),
  /** @deprecated Use USER_MANAGEMENT_VIEW — kept for existing imports */
  USER_LIST: Object.freeze({
    anyOf: [{ object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_VIEW }],
  }),
  USER_UPDATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  USER_UNLOCK: Object.freeze({
    allOf: [{ feature: AUTHZ_FEATURES.USER.UNLOCK }],
  }),
  USER_DELETE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.BASE_USER, action: AUTHZ_ACTIONS.CAN_DELETE }],
  }),

  BUSINESS_FUNCTION_VIEW: Object.freeze({
    anyOf: [{ object: AUTHZ_OBJECTS.ACCOUNT_INFO, action: AUTHZ_ACTIONS.CAN_VIEW }],
  }),
  BUSINESS_FUNCTION_CREATE: Object.freeze({ policy: 'super_admin_only' }),
  BUSINESS_FUNCTION_UPDATE: Object.freeze({
    anyOf: [{ object: AUTHZ_OBJECTS.ACCOUNT_INFO, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  BUSINESS_SERVICE_VIEW: Object.freeze({
    anyOf: [{ object: AUTHZ_OBJECTS.PROPOSAL_INFO, action: AUTHZ_ACTIONS.CAN_VIEW }],
  }),
  /** Routes + sidebar — requires module view and at least one scoped business function */
  BUSINESS_FUNCTIONS_ACCESS: Object.freeze({
    policy: 'business_functions_scoped',
  }),
  /** Lead form builder routes (/r/records/:campaignId/...); create action is gated separately */
  WORKSPACE_LEAD_FORMS: Object.freeze({
    policy: 'business_functions_scoped',
  }),

  MESSAGE_TEMPLATE_CREATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_CREATE }],
  }),
  MESSAGE_TEMPLATE_UPDATE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_UPDATE }],
  }),
  MESSAGE_TEMPLATE_DELETE: Object.freeze({
    allOf: [{ object: AUTHZ_OBJECTS.MESSAGE_TEMPLATE, action: AUTHZ_ACTIONS.CAN_DELETE }],
  }),
});

export { AUTHZ_FEATURES, AUTHZ_OBJECTS, AUTHZ_ACTIONS } from './features.constants';
